import {Component, OnInit} from '@angular/core';
import {UiUtilsModule} from '../../../ui-utils/ui-utils.module';
import {RouterOutlet} from '@angular/router';
import {DialogService} from 'primeng/dynamicdialog';
import {SupportRequestComponent} from '../../../dashboard/components/support-request/support-request.component';
import {CommonService} from '../../../services/common.service';
import {NgIf} from '@angular/common';
import {DashboardModule} from "../../../dashboard/dashboard.module";

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    UiUtilsModule,
    RouterOutlet,
    NgIf,
    DashboardModule
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.less'
})
export class MainLayoutComponent {
  constructor(private dialogService: DialogService) {}

  showFeedbackDialog(): void {
    this.dialogService.open(SupportRequestComponent, {
      header: 'Обратная связь',
      closable: true,
      modal: true,
      width: '400px',
    });
  }

}
